import React from "react"
import cn from "classnames"
import { RequiredMark, Help, ErrorMessage, describedBy } from "./Field"
import styles from "../../styles/scss/components/form/formSystem.module.scss"

// <fieldset> + <legend> for groups of radios or checkboxes. The group's help
// and error are tied to the fieldset with aria-describedby, which screen
// readers announce when focus enters the group.
const Fieldset = ({
    id,
    legend,
    required,
    help,
    error,
    row,
    className,
    children,
}) => (
    <fieldset
        id={id}
        className={cn(styles.section, className)}
        aria-describedby={describedBy(id, { help, error })}
    >
        <legend className={styles.legend}>
            {legend}
            {required && <RequiredMark />}
        </legend>
        <div className={cn(styles.options, { [styles.optionsRow]: row })}>
            {children}
        </div>
        <Help id={id}>{help}</Help>
        <ErrorMessage id={id}>{error}</ErrorMessage>
    </fieldset>
)

export default Fieldset
